"use strict";

var _axios = _interopRequireDefault(require("axios"));

require("../../styles/theme.scss");

var _themeSections = require("@shopify/theme-sections");

var _themeA11y = require("@shopify/theme-a11y");

require("../helpers/polyfill");

require("../helpers/lazysizes");

var _ajaxCart = _interopRequireDefault(require("../helpers/ajax-cart"));

var _eventBus = _interopRequireDefault(require("../helpers/event-bus"));

var _redirects = _interopRequireDefault(require("../helpers/redirects"));

var _utils = require("../helpers/utils");

require("../sections/cart-drawer");

require("../sections/menu-drawer");

require("../sections/site-header");

require("../sections/free-reads");

require("../sections/faqs");

require("../sections/collection-blocks");

require("../sections/collection-grid-slider");

require("../sections/collection-product-slider");

require("../sections/custom-featured-products");

require("../sections/custom-image-slider");

require("../sections/featured-collection");

require("../sections/hero-banner");

require("../sections/image-slider");

require("../sections/shop-by-theme");

var _languageSelector = _interopRequireDefault(require("../components/language-selector"));

var _searchBar = _interopRequireDefault(require("../components/search-bar"));

var _meganav = _interopRequireDefault(require("../components/meganav"));

var _directedEdge = _interopRequireDefault(require("../components/directed-edge"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Layout: Theme
 * -----------------------------------------------------------------------------
 * Entry file for all global theme scripts and registering sections and modules
 *
 */

/**
 * Global theme helpers.
 */

/**
 * Global theme section imports.
 */

/**
 * Global theme component imports.
 */

/**
* Global Frame utils
*/


window.Frame = window.Frame || {};
window.Frame.EventBus = (0, _eventBus["default"])();
document.addEventListener('DOMContentLoaded', function () {
  if ((0, _utils.getBrowser)() === 'Internet Explorer') {
    _axios["default"].defaults.headers.common = {
      // IE11 caching bug.
      Pragma: 'no-cache'
    };
  }

  (0, _themeSections.load)('*');
  (0, _ajaxCart["default"])().init();
  (0, _meganav["default"])().init();
  (0, _searchBar["default"])().init();
  (0, _directedEdge["default"])().init();

  if (theme.features.redirectModal) {
    (0, _redirects["default"])().init();
  }

  if (theme.features.redirectModal && theme.features.languageSelector) {
    (0, _languageSelector["default"])().init();
  }

  (0, _themeA11y.focusHash)();
  (0, _themeA11y.bindInPageLinks)();
});